<template>
  <div id="contenedor-editar-contrato-sub-tema">
    <v-card>
      <v-card-title class="secondary--text">
        Editar Sub Tema
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
          <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form v-model="formularioValido" ref="actualizarContratoSubTema">
          <v-row>
            <v-col cols="12">
              <custom-autocomplete
                v-model="subTema.idTema"
                label="Selecciona un tema"
                :items="getContratoTemas"
                itemText="descripcion"
                itemValue="id"
                clearable
              >
              </custom-autocomplete>
            </v-col>
            <v-col cols="12">
              <TextArea
                v-model="subTema.descripcion"
                label="Descripción"
                rows="2"
              >
              </TextArea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider class="bkground" />
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button @click="cerrar" tipo="formCancelar" label="Cancelar" class="mr-3">
        </custom-button>
        <custom-button
          @click="mixActualizarSubTema"
          :disabled="!formularioValido || enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Actualizar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CONTRATO_TEMAS from '@/graphql/querys/administracion/contratos/contrato/temas/contratoTemas.gql';
import mixSubTemasContrato from './mixSubTemasContrato';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';

export default {
  name: 'EditarContratoSubTema',
  mixins: [mixSubTemasContrato],
  components: {
    TextArea,
    CustomButton,
    CustomAutocomplete,
  },
  props: {
    contratoSubTemaEditar: {
      type: Object,
      required: true,
    },
    idContrato: {
      type: String,
      required: true,
    },
  },
  apollo: {
    contratoTemas: {
      query: CONTRATO_TEMAS,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  data() {
    return {
      enviandoFormulario: false,
      formularioValido: false,
      subTema: {
        idTema: this.contratoSubTemaEditar.idTema,
        descripcion: this.contratoSubTemaEditar.descripcion,
      },
    };
  },
  methods: {
    cerrar() {
      this.$refs.actualizarContratoSubTema.reset();
      this.$emit('cerrar');
    },
  },
  computed: {
    getContratoTemas() {
      if (!this.contratoTemas) return [];
      return this.contratoTemas;
    },
  },
};
</script>

<style lang="scss"></style>
